export default {
  id: "page2",
  header: "Dane osobowe",
  questions: [
    {
      id: "respondent_dzieci",
      number: "11",
      label:
        "Liczba dzieci i/ lub młodzieży (poniżej 18 roku życia) żyjących w Pana(i) gospodarstwie domowym *<br><small style='font-weight:normal;'>* wypełnij jeżeli chcesz żeby dzieci brały udział w badaniach</small>",
      type: "select",
      required: false,
      options: [
        { value: "", name: "" },
        // { value: "0", name: "Nie mam dzieci" },
        { value: "1", name: "1 dziecko" },
        { value: "2", name: "2 dzieci" },
        { value: "3", name: "3 dzieci" },
        { value: "4", name: "4 dzieci" },
        { value: "5", name: "5 dzieci" },
        { value: "6", name: "6 dzieci" },
        { value: "7", name: "7 dzieci" },
        { value: "8", name: "8 dzieci" },
        { value: "9", name: "9 dzieci" }
      ]
    },
    {
      label: "Płeć 1 dziecka",
      number: "11a",
      type: "radio",
      id: "dzieci_plec_1",
      required: true,
      show: [["respondent_dzieci", ">0"]],
      options: [
        { value: "0", name: "Dziewczynka" },
        { value: "1", name: "Chłopiec" }
      ]
    },
    {
      label: "Rok urodzenia 1 dziecka",
      number: "11b",
      type: "text",
      id: "dzieci_rokUrodzenia_1",
      required: true,
      validations: {
        isNumeric: true,
        higherThan: new Date().getFullYear() - 19,
        higherThanMsg:
          "Prosimy upewnić się, że wpisano właściwy rok urodzenia. Wpisana data wskazuje, że wiek dziecka przekracza 18 lat.",
        lowerThan: new Date().getFullYear() + 1
      },
      show: [["respondent_dzieci", ">0"]]
    },
    {
      label: "Płeć 2 dziecka",
      number: "11c",
      type: "radio",
      id: "dzieci_plec_2",
      required: true,
      show: [["respondent_dzieci", ">1"]],
      options: [
        { value: "0", name: "Dziewczynka" },
        { value: "1", name: "Chłopiec" }
      ]
    },
    {
      label: "Rok urodzenia 2 dziecka",
      number: "11d",
      type: "text",
      id: "dzieci_rokUrodzenia_2",
      required: true,
      validations: {
        isNumeric: true,
        higherThan: new Date().getFullYear() - 19,
        higherThanMsg:
          "Prosimy upewnić się, że wpisano właściwy rok urodzenia. Wpisana data wskazuje, że wiek dziecka przekracza 18 lat.",

        lowerThan: new Date().getFullYear() + 1
      },
      show: [["respondent_dzieci", ">1"]]
    },

    {
      label: "Płeć 3 dziecka",
      number: "11e",
      type: "radio",
      id: "dzieci_plec_3",
      required: true,
      show: [["respondent_dzieci", ">2"]],
      options: [
        { value: "0", name: "Dziewczynka" },
        { value: "1", name: "Chłopiec" }
      ]
    },
    {
      label: "Rok urodzenia 3 dziecka",
      number: "11f",
      type: "text",
      id: "dzieci_rokUrodzenia_3",
      required: true,
      validations: {
        isNumeric: true,
        higherThan: new Date().getFullYear() - 19,
        higherThanMsg:
          "Prosimy upewnić się, że wpisano właściwy rok urodzenia. Wpisana data wskazuje, że wiek dziecka przekracza 18 lat.",

        lowerThan: new Date().getFullYear() + 1
      },
      show: [["respondent_dzieci", ">2"]]
    },
    {
      label: "Płeć 4 dziecka",
      number: "11g",
      type: "radio",
      id: "dzieci_plec_4",
      required: true,
      show: [["respondent_dzieci", ">3"]],
      options: [
        { value: "0", name: "Dziewczynka" },
        { value: "1", name: "Chłopiec" }
      ]
    },
    {
      label: "Rok urodzenia 4 dziecka",
      number: "11h",
      type: "text",
      id: "dzieci_rokUrodzenia_4",
      required: true,
      validations: {
        isNumeric: true,
        higherThan: new Date().getFullYear() - 19,
        higherThanMsg:
          "Prosimy upewnić się, że wpisano właściwy rok urodzenia. Wpisana data wskazuje, że wiek dziecka przekracza 18 lat.",

        lowerThan: new Date().getFullYear() + 1
      },
      show: [["respondent_dzieci", ">3"]]
    },
    {
      label: "Płeć 5 dziecka",
      number: "11i",
      type: "radio",
      id: "dzieci_plec_5",
      required: true,
      show: [["respondent_dzieci", ">4"]],
      options: [
        { value: "0", name: "Dziewczynka" },
        { value: "1", name: "Chłopiec" }
      ]
    },
    {
      label: "Rok urodzenia 5 dziecka",
      number: "11j",
      type: "text",
      id: "dzieci_rokUrodzenia_5",
      required: true,
      validations: {
        isNumeric: true,
        higherThan: new Date().getFullYear() - 19,
        higherThanMsg:
          "Prosimy upewnić się, że wpisano właściwy rok urodzenia. Wpisana data wskazuje, że wiek dziecka przekracza 18 lat.",

        lowerThan: new Date().getFullYear() + 1
      },
      show: [["respondent_dzieci", ">4"]]
    },
    {
      label: "Płeć 6 dziecka",
      number: "11k",
      type: "radio",
      id: "dzieci_plec_6",
      required: true,
      show: [["respondent_dzieci", ">5"]],
      options: [
        { value: "0", name: "Dziewczynka" },
        { value: "1", name: "Chłopiec" }
      ]
    },
    {
      label: "Rok urodzenia 6 dziecka",
      number: "11l",
      type: "text",
      id: "dzieci_rokUrodzenia_6",
      required: true,
      validations: {
        isNumeric: true,
        higherThan: new Date().getFullYear() - 19,
        higherThanMsg:
          "Prosimy upewnić się, że wpisano właściwy rok urodzenia. Wpisana data wskazuje, że wiek dziecka przekracza 18 lat.",

        lowerThan: new Date().getFullYear() + 1
      },
      show: [["respondent_dzieci", ">5"]]
    },
    {
      label: "Płeć 7 dziecka",
      number: "11m",
      type: "radio",
      id: "dzieci_plec_7",
      required: true,
      show: [["respondent_dzieci", ">6"]],
      options: [
        { value: "0", name: "Dziewczynka" },
        { value: "1", name: "Chłopiec" }
      ]
    },
    {
      label: "Rok urodzenia 7 dziecka",
      number: "11n",
      type: "text",
      id: "dzieci_rokUrodzenia_7",
      required: true,
      validations: {
        isNumeric: true,
        higherThan: new Date().getFullYear() - 19,
        higherThanMsg:
          "Prosimy upewnić się, że wpisano właściwy rok urodzenia. Wpisana data wskazuje, że wiek dziecka przekracza 18 lat.",

        lowerThan: new Date().getFullYear() + 1
      },
      show: [["respondent_dzieci", ">6"]]
    },
    {
      label: "Płeć 8 dziecka",
      number: "11o",
      type: "radio",
      id: "dzieci_plec_8",
      required: true,
      show: [["respondent_dzieci", ">7"]],
      options: [
        { value: "0", name: "Dziewczynka" },
        { value: "1", name: "Chłopiec" }
      ]
    },
    {
      label: "Rok urodzenia 8 dziecka",
      number: "11p",
      type: "text",
      id: "dzieci_rokUrodzenia_8",
      required: true,
      validations: {
        isNumeric: true,
        higherThan: new Date().getFullYear() - 19,
        higherThanMsg:
          "Prosimy upewnić się, że wpisano właściwy rok urodzenia. Wpisana data wskazuje, że wiek dziecka przekracza 18 lat.",

        lowerThan: new Date().getFullYear() + 1
      },
      show: [["respondent_dzieci", ">7"]]
    },
    {
      label: "Płeć 9 dziecka",
      number: "11q",
      type: "radio",
      id: "dzieci_plec_9",
      required: true,
      show: [["respondent_dzieci", ">8"]],
      options: [
        { value: "0", name: "Dziewczynka" },
        { value: "1", name: "Chłopiec" }
      ]
    },
    {
      label: "Rok urodzenia 9 dziecka",
      number: "11r",
      type: "text",
      id: "dzieci_rokUrodzenia_9",
      required: true,
      validations: {
        isNumeric: true,
        higherThan: new Date().getFullYear() - 19,
        higherThanMsg:
          "Prosimy upewnić się, że wpisano właściwy rok urodzenia. Wpisana data wskazuje, że wiek dziecka przekracza 18 lat.",

        lowerThan: new Date().getFullYear() + 1
      },
      show: [["respondent_dzieci", ">8"]]
    },
    {
      id: "respondent_wyksztalcenie",
      number: "12",
      label: "Jakie jest Pana(i) wykształcenie?",
      type: "radio",
      required: true,
      multiline: true,
      options: [
        { value: "1", name: "Podstawowe" },
        { value: "2", name: "Gimnazjalne" },
        { value: "3", name: "Zawodowe" },
        { value: "4", name: "Średnie ogólne lub techniczne" },
        { value: "5", name: "Wyższe" }
      ]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/config/page2.js